import { useQueryClient, useMutation } from "@tanstack/react-query";
import catalogAPIs from "features/catalogue/api/catalogAPIs";
import { toast } from "react-toastify";

export const useDeleteCatalog = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: catalogAPIs.catalogDelete,
    onSuccess: (data) => {
      if (data?.data?.status === 200) {
        queryClient.invalidateQueries("catalogData");
        toast.success(data.data.message || `Catalog Delete successfully`, {
          position: "top-right",
          autoClose: 2000,
        });
      }
    },
    onError: (error) => {
      toast.error("An error occurred while deleting this catalog", {
        position: "top-right",
        autoClose: 2000,
      });
    },
  });
};
